<button (click)="openConfig.emit()" class="config-panel-toggle" color="primary" mat-fab type="button">
  <iconify-icon [icon]="icSettings" width="24" height="24"></iconify-icon>
</button>
